import React from 'react';
import { SideMenuItem }  from '../SidemenuItems';
import { Div } from '../../../../components/grid';

export default ({
  activeSidemenu,
}) => (
  <Div>
    <SideMenuItem to="/kontakt-os" title="Kontakt" active={activeSidemenu === 'Kontakt'} />
    <SideMenuItem to="/om-peter-skafte-aps" title="Om Peter Skafte ApS" active={activeSidemenu === 'OmOs'} />
    <SideMenuItem to="/historie" title="Historie" active={activeSidemenu === 'Historie'} />
  </Div>
);
